import React from "react";
import aboutUs from "../../PicesForPages/AboutUs.webp";
import FreeConsultation from "../Form/FreeConsultation";

function AboutUs() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={aboutUs}
          alt="aboutUsImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox">About Us</div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              At <span className="logoBoldColor">The Mortgageist</span>, we see
              our clients as unique individuals, not mere numbers. We steer
              clear of the generic loan formulas typically used by banks.
              Instead, we rely on "common sense" to guide you toward the most
              suitable loan options. Our connections span a diverse range of "A"
              rated lenders with top-notch rates, as well as private lenders
              specializing in hardship cases.
            </span>
            <span className="purchaseBottomLeftContent">
              With partnerships involving over 100 investors, we can secure the
              best rates for various loan programs, including 30-year, 20-year,
              15-year, and 10-year mortgages, 1-year, 3-year, and 5-year ARMs,
              as well as Conventional, Jumbo, Home Equity Lines, VA, and
              Commercial loans. Whether your needs require Full Documentation,
              No Documentation, Non-Owner Occupied (Investor), or Multi-Family
              loans, we’re committed to finding the perfect fit for you!
            </span>

            <br />
            <br />
            <br />
            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                className="purchaseBottomLeftButtonLink"
                target="_blank"
                rel="noreferrer"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
